import { EORI_RE } from '../../supabase/functions/_shared/eori.ts'
import { isValidUkEoriFormat } from './cds/eori.ts'

// What the job screen shows under an Importer / Consignee about the company's EORI -- pure, so it can be tested.
// EORI only: a missing EORI makes the import declaration impossible (the pre-submit check refuses it). The VAT number does not affect customs
// (and has its own checks on the invoicing side), so the job page says nothing about it: a notice that changes nothing gets ignored, and then
// the EORI notice gets ignored with it.
export interface PartyTax { loaded: boolean; error?: string | null; eori: string | null }

export type EoriState = 'ok' | 'ok_check_uk' | 'missing' | 'bad_format'

export interface PartyTaxStatus {
  eori: EoriState
  // Whether a click on the company arrow should open the company's Edit form on EORI (only when it is missing/wrong AND the user may edit companies).
  editTarget: 'eori' | null
}

export function partyTaxStatus(tax: PartyTax, canEdit: boolean): PartyTaxStatus | null {
  if (!tax.loaded) return null
  const eori = (tax.eori ?? '').trim().toUpperCase()
  let state: EoriState
  if (!eori) state = 'missing'
  else if (!EORI_RE.test(eori)) state = 'bad_format'
  else if (/^GB/.test(eori) && !isValidUkEoriFormat(eori)) state = 'ok_check_uk'
  else state = 'ok'
  return { eori: state, editTarget: canEdit && (state === 'missing' || state === 'bad_format') ? 'eori' : null }
}
